import {
	Button,
	Modal,
	__experimentalVStack as VStack,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import { useDispatch } from '@wordpress/data';
import { store as blockEditorStore } from '@wordpress/block-editor';
import { useUnsupportedBlocks } from '../utils';

const modalDescriptionId =
	'wp-block-query-enhanced-pagination-modal__description';

export default function EnhancedPaginationModal( {
	clientId,
	attributes: { enhancedPagination },
	setAttributes,
} ) {
	const [ isOpen, setOpen ] = useState( false );
	const hasUnsupportedBlocks = useUnsupportedBlocks( clientId );
	const { __unstableMarkNextChangeAsNotPersistent } =
		useDispatch( blockEditorStore );

	useEffect( () => {
		if ( enhancedPagination && hasUnsupportedBlocks ) {
			__unstableMarkNextChangeAsNotPersistent();
			setAttributes( { enhancedPagination: false } );
			setOpen( true );
		}
	}, [
		enhancedPagination,
		hasUnsupportedBlocks,
		setAttributes,
		__unstableMarkNextChangeAsNotPersistent,
	] );

	const closeModal = () => {
		setOpen( false );
	};

	const notice =
		__(
			'Currently, avoiding full page reloads is not possible when non-interactive or non-client Navigation compatible blocks from plugins are present inside the Query block.'
		) +
		' ' +
		__(
			'If you still want to prevent full page reloads, remove that block, then disable "Reload full page" again in the Query Block settings.'
		);

	return (
		isOpen && (
			<Modal
				title={ __( 'Query block: Reload full page enabled' ) }
				className="wp-block-query__enhanced-pagination-modal"
				aria={ {
					describedby: modalDescriptionId,
				} }
				role="alertdialog"
				focusOnMount="firstElement"
				isDismissible={ false }
				onRequestClose={ closeModal }
			>
				<VStack alignment="right" spacing={ 5 }>
					<span id={ modalDescriptionId }>{ notice }</span>
					<Button
						__next40pxDefaultSize
						variant="primary"
						onClick={ closeModal }
					>
						{ __( 'OK' ) }
					</Button>
				</VStack>
			</Modal>
		)
	);
}
